export default __webpack_public_path__ + "static/media/44m.38da0989.png";